import ApiCall from "../../utils/apiCall";
import { browserHistory } from "react-router";

const initialState = {
  isFetching: true,
  date_joined: "",
  landing_page_header: "",
  ships_from: "",
  supplier_alias: "",
  return_policy: ""
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "suppliers.isFetching":
      return { ...state, isFetching: true };

    case "suppliers.fetchSuccess":
      return { ...state, isFetching: false, ...action.response };

    case "suppliers.fetchError":
      return { ...state, isFetching: true, ...action.response };

    default:
      return state;
  }
}

// Actions
export function getSupplierData(supplierAlias) {
  return dispatch => {
    dispatch({ type: "suppliers.isFetching" });

    return ApiCall.get(`/suppliers/${supplierAlias}`)
      .then(response => {
        dispatch({
          type: "suppliers.fetchSuccess",
          response: response.json
        });
      })
      .catch(error => {
        dispatch({
          type: "suppliers.fetchError",
          response: error.json
        });
        browserHistory.push("/search");
      });
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/suppliers.js